<script lang="ts">
	import { omit } from "$lib/utils/object";
  import classnames from "classnames"

  const attributes = omit($$restProps, "class")
</script>

<section class="{classnames('section-certificates', $$props.class)}" {...attributes}>
  {#if $$slots.header}
    <div class="section-certificates-header">
      <slot name="header" />
    </div>
  {/if}

  <div class="content">
    <slot />
  </div>
</section>

<style type="text/scss" lang="scss" scoped>
  .section-certificates {
    @apply relative flex flex-col;
    @apply bg-courses-executiveMBA text-white;
    @apply md:mr-0;
    @apply mb-32;

    /* Avoid sudden interruption of the block with the grid gap */
    margin-left: calc(var(--page-margin) * -1);
    margin-right: calc(var(--page-margin) * -1);
    padding-left: var(--page-margin);
    padding-right: var(--page-margin);

    @screen lg {
      margin-left: calc((100vw - var(--page-current-width)) * -0.5 - var(--page-margin));
      padding-left: calc((100vw - var(--page-current-width)) * 0.5 + var(--page-margin));
      margin-right: calc(var(--page-margin) * -1);
      padding-right: var(--page-margin);
    }
  }

  .section-certificates-header {
    @apply flex flex-col items-center;
    @apply text-center;
    @apply py-6 md:py-14;
    @apply mx-auto;
    @apply max-w-3xl;
  }
  :global(.section-certificates-header > * + *) {
    @apply mt-6 md:mt-7;
  }

  .content {
    @apply mt-3 md:mt-5;
    @apply -mb-24;
  }
</style>
